import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { observer } from 'mobx-react-lite';
import { Routes, Route } from 'react-router-dom';
import {
  Alert,
  Form,
  Input,
  Row,
  Col,
  Tag,
  Select,
  Button,
  Switch,
  Tooltip,
} from 'antd';
import store from './store';
import Checkbox from './components/checkbox';
import Radio from './components/radio';
import Upload from './components/upload-qiniu';
import Header from './components/header';
import { HelperCore, HelpOther } from '@/common/helper';
import globalStore from '@/store/global';
import { SVGPureIcon } from '@ui/svg-icon';
import client from '@/store/client';
import { useParams } from 'react-router-dom';
import FormMain from './components/step-main';
import client360Store from '@public/client/client360';
import useVisibilityChange from './useVisibilityChange';
import knowledgeChoiceStore from '@/components/knowledge-choice/store';
import Prompt from './components/prompt';

import Conf from '@/common/conf';
import './index.scss';

const { TextArea } = Input;

const AgentCreate = observer(props => {
  const [form] = Form.useForm();
  const id = HelperCore.getQueryString('id');
  const server_id = HelperCore.getQueryString('server_id');
  let [current, setCurrent] = useState(1);
  const watchertitle = Form.useWatch('title', form);
  
  
  const [visibility] = useVisibilityChange();

  const { greeting, form_id, icon, genGreeting } = store;
  const [showPanelSize, setShowPanelSize] = useState('small');
  // const [prompt_form, setPromptForm] = useState([]);
  const [visiblePromptForm, setVisiblePromptForm] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [cardHeight, setCardHeight] = useState(0)
  

  const onFinish = values => {
    
    if (!values?.title?.trim()) {
      HelpOther.toast('请输入名称！');
      return;
    }

    if (!values.role_id) {
      HelpOther.toast('请选择模型！');
      return;
    }

    if (!values.input_func || !values.input_func.length) {
       HelpOther.toast('请选择设定输入框功能！');
      return;
    }
    // if (!store.agentImage) {
    //   HelpOther.toast('请上传图片');
    //   return;
    // }
    // if (!values.greeting) {
    //   HelpOther.toast('请输入欢迎语');
    //   return;
    // }

    // if (!(values.saylist_detail && values.saylist_detail.length)) {
    //   HelpOther.toast('请输入试着问问我');
    //   return;
    // }

    if (values.input_func && values.input_func.length) {
      values.input_func = values.input_func.join(',')
    }

    if (values.saylist_detail && values.saylist_detail.length) {
      values.saylist_detail = values.saylist_detail
        .map(item => {
          return item?.trim();
        })
        .filter(item => !!item);
    }

    if (values.prompt_list && values.prompt_list.length) {
      values.prompt_list = values.prompt_list
        .map(item => {
          return item?.trim();
        })
        .filter(item => !!item);
    }

    if (values.server_list && values.server_list.length) {
      values.server_list = values.server_list.map(id => {
        const item = store.getCurrentMcp(id) || {};
        return {
          server_id: id,
          server_name: item.server_name,
          display_name: item.display_name,
          is_local: item.is_local,
        };
      });
    }

    if (id) {
      values.id = id;
    }

    values.prompt_form = store.prompt_form?.map(item => item.form_id);

    store.createMcp({
      ...values,
      title: values.title?.trim(),
      icon: store.agentImage,
    })
  };

  const OnSetCurrent = useCallback(() => {
    current = current > 1 ? --current : ++current;
    setCurrent(current);
  }, [current]);

  useEffect(() => {
    if (visibility) {
      store.loadMCPlist();
    }
  }, [visibility]);

  useEffect(() => {
    form.setFieldValue('saylist_detail', [' ']);
    // form.setFieldValue('prompt_list', ['']);
    
    store.prompt_form = [];
    window.addEventListener('message', iframeMessage);

    return () => {
      window.removeEventListener('message', iframeMessage);
      store.resetForm();
      form.setFieldsValue({});
    };
  }, []);

  // 编辑
  useEffect(() => {
    if (id) {
      store.getMcpDetail(id).then(data => {
        if (data) {
          let {
            greeting,
            server_list,
            dataset_id,
            saylist_detail,
            prompt_list,
            title,
            intro,
            role_id,
            prompt_form,
            visitable,
            input_tip,
            input_func
          } = data;

          store.prompt_form = prompt_form;

          if (!saylist_detail?.length) {
            saylist_detail = [' '];
          }
          

          // if (!prompt_list?.length) {
          //   prompt_list = [];
          // }
          // role_id == '123'
          // 判断是否在列表中
          const isInModelList = store.modelList?.find(
            item => item.role_id == role_id
          );
          if (!role_id || !isInModelList) {
            // 老数据没有设置模型，设置列表里第一条mcplist
            const curRole = store.modelList?.find(item => item.support_mcp);
            role_id = curRole?.role_id;
            // form.setFieldValue('role_id', curRole?.role_id);
          }

          let tempServer = [];

          if (server_list?.length) {
            server_list = server_list.map(item => item.server_id);
            // server_list = [1111, 222, 10085];
            server_list.forEach((item, i) => {
              const index = store.mcpList.findIndex(
                mcpItem => mcpItem.server_id == item
              );
              if (index > -1) {
                // const serverIndex = server_list.findIndex((item) => item == )
                tempServer.push(item);
              }
            });
          }
          
          form.setFieldsValue({
            greeting,
            server_list: tempServer,
            dataset_id,
            saylist_detail,
            prompt_list,
            title,
            intro,
            role_id,
            visitable,
            input_tip,
            input_func
          });
        }
      });
    }

    if (!id) {
      // 创建设置默认项
      form.setFieldValue('visitable', 1);
      form.setFieldValue('input_func', ['1']);
      let curRole = store.modelList?.find(item => {
        // 获取不到默认推荐项，选择第一个支持mcp
        return item.select;
      });
      if (!curRole) {
        curRole = store.modelList?.find(item => {
          // 获取不到默认推荐项，选择第一个支持mcp
          return item.support_mcp;
        });
      }
      form.setFieldValue('role_id', curRole?.role_id);
    }
  }, [id, form]);

  useEffect(() => {
    // 默认选中 server_id
    // let  serverList = form.getFieldValue('server_list')
    if (server_id && store.mcpList?.length) {
      form.setFieldValue('server_list', [Number(server_id)]);
    }
  }, [server_id, store.mcpList]);

  useEffect(() => {
    if (store.visiblePromptForm) {
      let url = `https://n.agent.360.cn/form/generator?mid=${client360Store.mid}&agent_id=${id || ''}`;
      if (form_id) {
        url += `&type=edit&form_id=${form_id}`;
      } else {
        url += '&type=add';
      }
      setIframeUrl(url);
    }
  }, [id, store.visiblePromptForm]);

  const iframeMessage = e => {
    const { origin, source, data } = e;
    const { type, msg } = data || {};

    if (type === 'add') {
      store.prompt_form.push({
        form_id: msg.form_id,
        name: msg.name,
      });
      store.setVisiblePromptForm(false);
    } else if (type === 'edit') {
      const find = store.prompt_form.find(item => item.form_id === msg.form_id);
      if (find) {
        find.name = msg.name;
      }
      store.setVisiblePromptForm(false);
    } else if (type === 'close') {
      store.setVisiblePromptForm(false);
    }
  };

  

  // 同步ai生成内容
  useEffect(() => {
    if (watchertitle?.trim()) {
      store.setDisableGened(false);
    } else {
      store.setDisableGened(true);
    }
  }, [watchertitle]);

  useEffect(() => {
    form.setFieldValue('greeting', greeting);
  }, [form, greeting]);

  // useEffect(() => {
  //   const cardArea = document.getElementById('promptCard');
  //   const height = cardArea.clientHeight - 34 - 38 -32 - 20  -20;
  //   setCardHeight(height)
  //   console.log('cardArea is', height)
  // }, [])

    useEffect(() => {
      const handleResize = () => {
        
        const cardArea = document.getElementById('promptCard');
        const height = cardArea.clientHeight - 34 - 38 -32 - 20  -20;
        setCardHeight(height) 
      };
      handleResize()
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

  return (
    <div className="w-full h-full  flex flex-col create-wcp-modal">
      {store.visiblePromptForm ? (
        <div className="size-full absolute left-0 top-0 z-100">
          <iframe src={iframeUrl} className="size-full"></iframe>
        </div>
      ) : null}

      <Header store={store} form={form} server_id={server_id} id={id} />
      <div className="flex-1 flex overflow-hidden">
        <Form
          onFinish={onFinish}
          form={form}
          name="trigger"
          layout="vertical"
          autoComplete="off"
          className="flex  flex-1"
        >
          <div className="w-1\/2  pt-19px pl-32px pr-28px box-border nw-scrollbar-thin pb-10px flex-1 overflow-y-auto">
            <div>
              <FormMain visible={current === 1} form={form} />
            </div>
          </div>
          <div id="promptCard" className="w-1\/2  box-border border-l-1px border-l-[rgba(0,0,0,0.10)] pb-10px bg-[rgba(0,0,0,0.03)] pt-24px pl-36px pr-32px nw-scrollbar-thin flex-1 overflow-y-auto">
            <Prompt height={cardHeight} form={form} />
          </div>
        </Form>
      </div>

      {/* <div className="flex w-712px mx-auto  gap-16px mt-22px ">
        {current == 2 ? (
          <div className="flex-1">
            <Button
              onClick={() => {
                form.submit();
              }}
              loading={store.sunmitLoading}
              className="wcp-btn !w-full !h-44px"
              type="primary"
              htmlType="submit"
            >
              保存AI智能体
            </Button>
          </div>
        ) : null}

        <div
          onClick={OnSetCurrent}
          className="h-44px flex-1 leading-44px cursor-pointer text-center rounded-12px bg-[rgba(0,0,0,0.06)] hover:bg-[rgba(0,0,0,0.09)] text-[rgba(0,0,0,0.85)] text-16px font-medium"
        >
          {current > 1 ? '上一页' : '下一页'}
        </div>
      </div> */}
    </div>
  );
});

export default AgentCreate;
